module.exports = __webpack_public_path__ + "img/About - FIRSTfirstdown.10ff1a8c.png";